import type { AccentHue } from "@repo/fika-design-system/color"
import type { IconName } from "@repo/fika-design-system/icon"
import { type ParentProps, Show } from "solid-js"
import { Button } from "@/designSystem/components/button"
import { Icon } from "@/designSystem/components/icon"
import {
  iconClass,
  linkClass,
  sectionClass,
  sectionTitleClass,
  sectionTitleContentClass,
} from "./_dashboard-section.css"

export function DashboardSection(
  props: ParentProps & {
    title: string
    iconName: IconName
    hue: AccentHue
    link?: {
      href: string
      text: string
    }
    action?: {
      onClick: () => void
      active?: boolean
    }
  },
) {
  return (
    <div class={sectionClass}>
      <div class={sectionTitleClass}>
        <Icon
          name={props.iconName}
          size="24"
          class={iconClass({ hue: props.hue })}
        />
        <span class={sectionTitleContentClass({ hue: props.hue })}>
          {props.title}
        </span>
        <Show when={props.link}>
          {link => (
            <a
              href={link().href}
              title={link().text}
              class={linkClass({ hue: props.hue })}
            >
              <Icon name="arrow-right" size="18" />
            </a>
          )}
        </Show>
        <Show when={props.action}>
          {action => (
            <Button
              hue={props.hue}
              kind="ghost"
              size="s"
              iconName="rotate-cw"
              onClick={action().onClick}
              active={action().active}
            />
          )}
        </Show>
      </div>
      {props.children}
    </div>
  )
}
